/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 5/9/13
 * Time: 1:54 PM
 * To change this template use File | Settings | File Templates.
 *
 * the layout which holds the title and the grid region of the component
 */

define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var Logger = require('logger');
    var template = require('ui/single-select/templates/singleSelect.tmpl');


    var SingleSelectLayout = Marionette.Layout.extend({
        template:template,
        regions:{
            title:'.title-wrap',  //title on the top
            grid:'.grid'     //the categories + items
        },
        initialize:function (options) {
            this.logger = Logger.getLogger('SingleSelect');
        }
    });

    return SingleSelectLayout;
});

